import { ElLoading } from 'element-plus'; // Falls du element-plus verwendest

type LoadingOptionsResolved = {
	target?: HTMLElement;
};

export const startLoading = (targetSelector: string): ReturnType<typeof ElLoading.service> => {
	const loadingTarget = (document.querySelector(targetSelector) as HTMLElement) || undefined;
	const options: Partial<LoadingOptionsResolved> = { target: loadingTarget };
	return ElLoading.service(options);
};

export const stopLoading = (loadingInstance: ReturnType<typeof ElLoading.service>): void => {
	if (loadingInstance) {
		loadingInstance.close();
	}
};
